import React from "react"
import { Row, Col, Switch, Typography } from "antd"

const { Paragraph } = Typography

export interface EmailPreference {
  emailChannelId: number
  channelKey: string
  description: string
  isUserControllable: boolean
  isCritical: boolean
  isSubscribed: boolean
  lastChangedAt: string | null
  lastChangedSource: string | null
}

interface Props {
  preferences: EmailPreference[]
  readOnly?: boolean
  onToggle?: (pref: EmailPreference, isSubscribed: boolean) => void
}

export const EmailPreferencesPanel: React.FC<Props> = ({
  preferences,
  readOnly = false,
  onToggle,
}) => {
  const hasPreferences = preferences && preferences.length > 0

  if (!hasPreferences) {
    return (
      <Paragraph type="secondary" style={{ marginTop: 8 }}>
        No email preferences are available for this account yet.
      </Paragraph>
    )
  }

  return (
    <>
      <div style={{ marginBottom: 12 }}>
        <Paragraph type="secondary" style={{ fontSize: 12 }}>
          You may update the user's email preferences by toggling the desired unsubscribe groups below.
          Certain critical email channels (billing, activation, critical transactions) cannot be unsubscribed from and are not shown here.
        </Paragraph>
      </div>
      {preferences.map((pref) => (
        <Row
          key={pref.emailChannelId}
          style={{ maxWidth: 560, paddingBottom: 12 }}
          align="middle"
        >
          <Col span={18}>
            <div style={{ fontWeight: 500 }}>
              {pref.description || pref.channelKey}
            </div>
            <div style={{ fontSize: 12, color: "#8898aa" }}>
              {pref.isSubscribed
                ? "You are subscribed to these emails."
                : "You are unsubscribed from these emails."}
            </div>
          </Col>
          <Col span={6} style={{ textAlign: "right" }}>
            <Switch
              checked={pref.isSubscribed}
              disabled={readOnly || !onToggle}
              onChange={(checked) => onToggle && onToggle(pref, checked)}
            />
          </Col>
        </Row>
      ))}
    </>
  )
}

export default EmailPreferencesPanel
